var map = {
	"./404.svg": "8e71",
	"./SHENG ZOU.png": "766b",
	"./bg.jpg": "d1b4",
	"./home-banner.jpg": "bebd",
	"./home-banner.png": "0159",
	"./home1.png": "9b33",
	"./home2.png": "4b40",
	"./home3.png": "b899",
	"./home4.png": "0e42",
	"./home5.png": "b82b",
	"./home6.png": "776f",
	"./logo1.jpg": "bff4",
	"./logo1.png": "8f1f",
	"./logo2.png": "440d",
	"./logo3.png": "7cbd",
	"./map.png": "48dd",
	"./menu_tab.svg": "326c",
	"./product-icon1.png": "700e",
	"./product-icon2.png": "536c",
	"./product-icon3.png": "4261",
	"./product-icon4.png": "acfb",
	"./product-icon5.png": "ce05",
	"./product-icon6.png": "65ab",
	"./product1.png": "4072",
	"./product2.png": "b7e4",
	"./product3.png": "fb9e",
	"./product4.png": "e9d8",
	"./product5.png": "8a1c",
	"./product6.png": "6c64",
	"./product7.png": "427a",
	"./productView1.png": "ee3e",
	"./productView2.png": "f5a4",
	"./productView3.png": "df32",
	"./productView4.png": "dbac",
	"./productView5.png": "556e",
	"./productView6.png": "fe80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";